/**
 * Abrir el documento de una tarjeta, en una barrita que aparece sobre ella al
 * seleccionarla.
 *
 * Va por acá y no por un menú al hacer click porque el click sobre una tarjeta
 * ya significa otra cosa (seleccionar, arrastrar, marquesina): un menú que se
 * abriera ahí habría que cerrarlo antes de poder mover nada. Esto se limita a
 * acompañar a la selección y desaparece con ella.
 */

export interface CardActionsCallbacks {
  /** Abrir en la vista completa (reemplaza el canvas). */
  onFullView: (path: string) => void;
}

export interface CardActionsRect {
  x: number;
  y: number;
  width: number;
  height: number;
  scale: number;
}

/** Separación entre el borde de arriba de la tarjeta y la barra, en píxeles de pantalla. */
const GAP_PX = 10;

export class CardActions {
  readonly root: HTMLElement;
  private path: string | null = null;
  /** Última posición aplicada, para no tocar el DOM en cada frame sin motivo. */
  private lastLeft = NaN;
  private lastTop = NaN;

  constructor(cb: CardActionsCallbacks) {
    this.root = document.createElement("div");
    this.root.className = "card-actions";
    this.root.hidden = true;

    const make = (label: string, run: (path: string) => void): HTMLElement => {
      const btn = document.createElement("button");
      btn.className = "card-action";
      btn.textContent = label;
      // El canvas escucha `pointerdown` para arrastrar: sin esto, apretar un
      // botón empezaba a mover la tarjeta de abajo.
      btn.addEventListener("pointerdown", (e) => e.stopPropagation());
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        if (this.path) run(this.path);
      });
      return btn;
    };

    // El camino para IRSE a la nota. El doble click sobre la tarjeta la abre al
    // costado, sin soltar el lienzo; esto es lo otro, y por eso sigue estando.
    this.root.append(make("Full view", cb.onFullView));
  }

  /** Coloca la barra centrada sobre la tarjeta. */
  show(path: string, rect: CardActionsRect): void {
    if (path !== this.path) {
      this.path = path;
      this.root.hidden = false;
    }
    const left = Math.round(rect.x + (rect.width * rect.scale) / 2);
    const top = Math.round(rect.y - GAP_PX);
    if (left !== this.lastLeft || top !== this.lastTop) {
      this.lastLeft = left;
      this.lastTop = top;
      this.root.style.left = `${left}px`;
      this.root.style.top = `${top}px`;
    }
  }

  hide(): void {
    if (this.path === null) return;
    this.path = null;
    this.root.hidden = true;
  }
}
